import {CheckGlyph, MinusGlyph} from '@/components/ui/icons'
import {cn} from '@/lib/utils'

/** A `role="checkbox"` button painted from tokens, not a raw input, so it matches the design system. */
export function Checkbox({
  checked,
  indeterminate,
  onCheckedChange,
  disabled,
  className,
  ...props
}: Omit<React.ComponentProps<'button'>, 'onClick' | 'type' | 'checked'> & {
  checked: boolean
  indeterminate?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : checked}
      disabled={disabled}
      onClick={() => onCheckedChange?.(!checked)}
      className={cn(
        'inline-flex size-4 shrink-0 items-center justify-center rounded-[4px] border transition-colors outline-none focus-visible:ring-3 focus-visible:ring-ring/50',
        checked || indeterminate
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-input bg-card hover:border-[color-mix(in_oklch,var(--input),var(--foreground)_18%)]',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className
      )}
      {...props}>
      {indeterminate ? <MinusGlyph /> : checked ? <CheckGlyph size={13} /> : null}
    </button>
  )
}
